export const dashboard = {
  title: "Tableau de bord intuitif",
  subtitle: "Gérez tous vos échanges depuis une interface simple et moderne",
  features: {
    stats: {
      title: "Statistiques détaillées",
      description:
        "Suivez vos Nuits, échanges et économies réalisées en temps réel",
    },
    notifications: {
      title: "Notifications intelligentes",
      description:
        "Recevez des alertes pour les nouvelles demandes et messages importants",
    },
    management: {
      title: "Gestion simplifiée",
      description:
        "Gérez vos disponibilités, réservations et échanges en quelques clics",
    },
  },
  cta: "Découvrir le tableau de bord",
  exchangeConfirmed: "Échange confirmé",
  newRequests: "nouvelles demandes",
  toReview: "À examiner",
};
